import nxtArrival from "../../assets/img/nxtEvents/LogoOnlysPPV/Arrival.png";
import nxtTakeOver from "../../assets/img/nxtEvents/LogoTakeOver/TakeOver.png";
import nxtStandAndDeliver from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2026.png";
import nxtWarGames from "../../assets/img/nxtEvents/LogoWarGames/WarGames2021.png";
import nxtInYourHouse from "../../assets/img/nxtEvents/LogoIYH/InYourHouse2022.png";
import nxtWorldsCollide from "../../assets/img/nxtEvents/LogoWorldsCollide/WorldsCollide.png";
import nxtHalloweenHavoc from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2025.png";
import nxtDeadline from "../../assets/img/nxtEvents/LogoDeadl1ne/Deadl1ne2025.png";
import nxtVengeanceDay from "../../assets/img/nxtEvents/LogoVengeanceDay/VengeanceDay2026.png";
import nxtBattleground from "../../assets/img/nxtEvents/LogoBattleground/Battleground2025.png";
import nxtGreatAmericanBash from "../../assets/img/nxtEvents/LogoGAB/TGAB2026.png";
import nxtNoMercy from "../../assets/img/nxtEvents/LogoNoMercy/NoMercy2025.png";
import nxtHeatWave from "../../assets/img/nxtEvents/LogoHeatwave/Heatwave2026.png";

export const nxtEvents = [
  {
    id: "nxt-arrival",
    name: "ARRIVAL",
    image: nxtArrival,
    alt: "NXT Arrival event poster",
  },
  {
    id: "nxt-take-over",
    name: "TAKEOVER",
    image: nxtTakeOver,
    alt: "NXT TakeOver event poster",
  },
  {
    id: "nxt-stand-and-deliver",
    name: "STAND & DELIVER",
    image: nxtStandAndDeliver,
    alt: "NXT Stand & Deliver event poster",
  },
  {
    id: "nxt-war-games",
    name: "WARGAMES",
    image: nxtWarGames,
    alt: "NXT WarGames event poster",
  },
  {
    id: "nxt-in-your-house",
    name: "IN YOUR HOUSE",
    image: nxtInYourHouse,
    alt: "NXT In Your House event poster",
  },
  {
    id: "nxt-worlds-collide",
    name: "WORLDS COLLIDE",
    image: nxtWorldsCollide,
    alt: "NXT Worlds Collide event poster",
  },
  {
    id: "nxt-halloween-havoc",
    name: "HALLOWEEN HAVOC",
    image: nxtHalloweenHavoc,
    alt: "NXT Halloween Havoc event poster",
  },
  {
    id: "nxt-deadline",
    name: "DEADLINE",
    image: nxtDeadline,
    alt: "NXT Deadline event poster",
  },
  {
    id: "nxt-vengeance-day",
    name: "VENGEANCE DAY",
    image: nxtVengeanceDay,
    alt: "NXT Vengeance Day event poster",
  },
  {
    id: "nxt-battleground",
    name: "BATTLEGROUND",
    image: nxtBattleground,
    alt: "NXT Battleground event poster",
  },
  {
    id: "nxt-great-american-bash",
    name: "THE GREAT AMERICAN BASH",
    image: nxtGreatAmericanBash,
    alt: "NXT The Great American Bash event poster",
  },
  {
    id: "nxt-no-mercy",
    name: "NO MERCY",
    image: nxtNoMercy,
    alt: "NXT No Mercy event poster",
  },
  {
    id: "nxt-heat-wave",
    name: "HEATWAVE",
    image: nxtHeatWave,
    alt: "NXT Heatwave event poster",
  },
];
